import { render } from "./VCard.vue?vue&type=template&id=04471514"
import script from "./VCard.vue?vue&type=script&lang=js"
export * from "./VCard.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__